module.exports = __webpack_public_path__ + "img/b68d4806330fa8cdd6ed3d89c7081ef2.png";